import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatBid,
  RECOMMENDATION_TYPES,
  CONTEXTUAL_ENTITY_TYPE,
  MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS
} from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';

import template from './bid-adjustment-todo.pug';

const defaultItemCountInGrid = {
  [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: 1,
};

export class BidAdjustmentTodoColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isMCC }) {
    super({
      name: 'BidAdjustmentTodo',
      property: 'BidAdjustmentTodo',
      // [TODO] delete it
      title: i18n.getString('ColumnName_WhatYouCanDo') || '__what you can do__',
      bodyClasses: ['grid-column-BidAdjustmentTodo', 'actionable'],
      colClasses: ['col-superLongText'],
      sortable: false,
      type: 'string',
    });
    this.i18n = i18n;
    this.isMCC = isMCC;
  }

  template({
    value: {
      OpportunityType,
      Opportunities,
      Target: {
        CampaignName,
        CampaignId,
        AccountName,
        AccountId,
      },
    },
  }) {
    const { i18n } = this;
    const fromCampaign = _.find(
      Opportunities[0].SuggestedCampaignBudgets,
      campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Surplus
    );
    const toCampaign = _.find(
      Opportunities[0].SuggestedCampaignBudgets,
      campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Deficit
    );
    const title = i18n.getString(`Recommendation_Grid_${OpportunityType}_Todo_Title`, {
      name: withContextualAttributeTemplate({
        opportunityId: Opportunities[0].OpportunityId,
        entityName: CampaignName,
        entityId: CampaignId,
        entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
        status: 'false',
        ariaLabel: i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: CampaignName }),
      }),
      count: _.size(Opportunities),
      budget: formatBid(_.isUndefined(fromCampaign) ?
        0 : toCampaign.BudgetDeficit, i18n, i18n.currency),
      targetCPA: formatBid(Opportunities[0].BidStrategyTargetCpa || 0, i18n, i18n.currency),
    });

    const raiseList = [];
    const lowerList = [];
    let tooltipRaiseHeader;
    let tooltipLowerHeader;
    let hideDeltaRange;

    const list = _.map(Opportunities, (item) => {
      let description;
      let range;
      let model;
      let isAdoptAutoBidding;

      switch (OpportunityType) {
        case RECOMMENDATION_TYPES.REALLOCATE_BUDGET:
          model = {
            fromCampaign: withContextualAttributeTemplate({
              opportunityId: item.OpportunityId,
              entityName: fromCampaign.CampaignName,
              entityId: fromCampaign.CampaignId,
              entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
              status: 'false',
              ariaLabel: i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: fromCampaign.CampaignName }),
            }),
            toCampaign: withContextualAttributeTemplate({
              opportunityId: item.OpportunityId,
              entityName: toCampaign.CampaignName,
              entityId: toCampaign.CampaignId,
              entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
              status: 'false',
              ariaLabel: i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: toCampaign.CampaignName }),
            }),
          };
          break;
        default:
          break;
      }

      return _.defaults({}, item, {
        subtitle: !isAdoptAutoBidding ? i18n.getString(`Recommendation_Grid_${OpportunityType}_Todo_Item`, model) :
          withContextualAttributeTemplate({
            opportunityId: item.OpportunityId,
            entityName: i18n.getString(`Recommendation_Grid_${OpportunityType}_Todo_Item`, model),
            entityId: item.OpportunityId,
            entityType: CONTEXTUAL_ENTITY_TYPE.ADOPTAUTOBIDDING,
            status: 'false',
          }),
        range,
        description,
      });
    });

    let subtitle = i18n.getString(`Recommendation_Grid_${OpportunityType}_Todo_Subtitle`) || '';
    subtitle += _.map(_.first(list, defaultItemCountInGrid[OpportunityType]), i => i.subtitle).join(', ');

    let more;
    if (_.size(Opportunities) - defaultItemCountInGrid[OpportunityType] > 0) {
      subtitle += ', ';
      more = `+${i18n.getString('Recommendation_Grid_Todo_More', {
        count: _.size(Opportunities) - defaultItemCountInGrid[OpportunityType],
      })}`;
    }

    return template({
      title,
      subtitle,
      more,
      raiseList,
      lowerList,
      tooltipRaiseHeader,
      tooltipLowerHeader,
      hideDeltaRange,
      accountName: withContextualAttributeTemplate({
        opportunityId: Opportunities[0].OpportunityId,
        entityName: AccountName,
        entityId: AccountId,
        entityType: CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
        status: 'false',
      }),
      isMCC: this.isMCC,
    });
  }

  get property() {
    return {
      get: _.identity,
      property: 'BidAdjustmentTodo',
    };
  }
}
